import { RootState } from 'store/rootTypes';

export const InterStateSelector = (state: RootState) => state.InterState;
